import React, { useEffect, useState } from 'react';

import { toastError, toastSuccess } from '@components/Toast';

import {
	renderColorsColumn,
	renderFabricComposition,
	renderFabricType
} from '@features/material-requisition/utils';
import { useUpdateMaterialRequisitionPreliminaryItemMutation } from '@features/material-requisition/api/materialRequisitionApi';

import { capitalizeFirstLetter } from '@utils/Util';

const MaterialPreliminaryItemTable = ({ materials = [], selectedRequisition }) => {
	const [materialList, setMaterialList] = useState([]);
	const [updateMaterialRequisitionPreliminaryItem] = useUpdateMaterialRequisitionPreliminaryItemMutation();

	useEffect(() => {
		setMaterialList(materials);
	}, [materials]);

	const isFabricAndSwatch = () => {
		return ['FABRIC', 'SWATCH'].includes(selectedRequisition.requisitionType);
	};

	const triggerEdit = async (material) => {
		if (material?.isEditing) {
			const { id, quantity, cost } = material;
			try {
				await updateMaterialRequisitionPreliminaryItem({
					requestBody: { id, quantity, price: cost || null }
				}).unwrap();
				onChangeHandler({ target: { value: false } }, material, 'isEditing');
				toastSuccess('Updated successfully');
			} catch {
				toastError('Failed to update');
			}
		} else {
			onChangeHandler({ target: { value: true } }, material, 'isEditing');
		}
	};

	const onChangeHandler = (e, material, name) => {
		const updatedMaterialList = materialList.map((item) => {
			if (item.id === material.id) {
				return { ...item, [name]: e.target.value };
			}
			return item;
		});
		setMaterialList(updatedMaterialList);
	};

	const renderEditingState = (material, name) => {
		if (material.isEditing) {
			return (
				<div>
					<input
						type="text"
						value={material?.[name] || ''}
						onChange={(e) => onChangeHandler(e, material, name)}
						readOnly={selectedRequisition.requisitionType === 'SWATCH' && name === 'quantity'}
					/>
				</div>
			);
		} else {
			return <>{material?.[name]}</>;
		}
	};

	return (
		<div className="material-requirement-table">
			<table className="table height-sm hover with-border">
				<thead>
					<tr>
						{isFabricAndSwatch() && <th>Fabric Type</th>}
						{isFabricAndSwatch() && <th>Fabric details</th>}
						{!isFabricAndSwatch() && (
							<th>{capitalizeFirstLetter(selectedRequisition.requisitionType)} category</th>
						)}
						<th>Colors</th>
						<th>Quantity</th>
						<th>Total estimated price (BDT)</th>
						<th>Action</th>
					</tr>
				</thead>
				<tbody>
					{materialList?.map((material) => (
						<tr key={`material_${material?.id}`}>
							{isFabricAndSwatch() && <td>{renderFabricType(material)}</td>}
							{isFabricAndSwatch() && (
								<td>
									<p>{renderFabricComposition(material)}</p>
								</td>
							)}
							{!isFabricAndSwatch() && (
								<td>
									<p>
										{selectedRequisition.requisitionType === 'TRIMS'
											? material?.trimsCategory
											: material?.accessoriesCategory}
									</p>
								</td>
							)}
							<td>{renderColorsColumn([{ ...material?.materialColorResponse }])}</td>
							<td>
								<div className="d-flex align-items-center gap-2">
									{renderEditingState(material, 'quantity')}
									{selectedRequisition.requisitionType === 'SWATCH' ||
									['TRIMS', 'ACCESSORIES'].includes(selectedRequisition.requisitionType)
										? ' pcs'
										: renderFabricType(material) === 'Knit'
											? ' Kg'
											: ' Yard'}
								</div>
							</td>
							<td>{renderEditingState(material, 'cost')}</td>
							<td>
								{['MATERIAL_ADDED', 'REQUESTED'].includes(selectedRequisition.status) && (
									<span
										className="regular-14 blue cursor-pointer"
										onClick={() => triggerEdit(material)}
									>
										{material.isEditing ? 'Update' : 'Edit'}
									</span>
								)}
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};

export default MaterialPreliminaryItemTable;
